import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { formatDate, parseDate } from '@jd/jmtd-tools/es/date';
import DatePickerHeader from '../DatePickerHeader';
import Calendar from '../Calendar';
import DatePickerDropdownList from '../DatePickerDropdownList';
import { getLocale } from '../locale';
import { dateSelectedState, formatDay, parsePanelConfig } from '../tools/date';
var DayPanel = {
  type: 'day',
  dateType: 'day',
  label: function label() {
    return getLocale(this.locale).datePicker.picker.day.label;
  },
  echo: function echo(value) {
    return getLocale(this.locale).datePicker.picker.day.echo(value);
  },
  render: function render(_ref) {
    var value = _ref.value,
        state = _ref.state,
        update = _ref.update,
        _ref$config = _ref.config,
        defaultPickerValue = _ref$config.defaultPickerValue,
        pickerConfig = _ref$config.pickerConfig,
        _ref$config$isDateDis = _ref$config.isDateDisabled,
        _isDateDisabled = _ref$config$isDateDis === void 0 ? function () {
      return false;
    } : _ref$config$isDateDis,
        _ref$config$isValueDi = _ref$config.isValueDisabled,
        isValueDisabled = _ref$config$isValueDi === void 0 ? function () {
      return false;
    } : _ref$config$isValueDi,
        firstDayOfWeek = _ref$config.firstDayOfWeek;

    var selectedDate = value && parseDate(value); // 选中的日期

    var panelDate = state.currentDate || selectedDate || defaultPickerValue && new Date(defaultPickerValue[0], defaultPickerValue[1] - 1) || new Date(); // 面板日期，比如2020年03月

    return {
      dropdown: /*#__PURE__*/React.createElement(DatePickerDropdownList, {
        className: "jmtd-date-picker-day-panel"
      }, /*#__PURE__*/React.createElement(DatePickerHeader, _extends({
        date: panelDate
      }, parsePanelConfig(pickerConfig, panelDate), {
        onSwitch: function onSwitch(nextDate) {
          // 切换面板日期
          state.currentDate = nextDate;
          update();
        }
      })), /*#__PURE__*/React.createElement(Calendar, {
        firstDayOfWeek: firstDayOfWeek,
        date: panelDate,
        isDateDisabled: function isDateDisabled(dateItem) {
          return _isDateDisabled(dateItem) || isValueDisabled(formatDay(dateItem));
        },
        render: function render(dateItem) {
          return {
            stateClass: dateSelectedState(dateItem, [selectedDate, selectedDate], panelDate),
            onClick: function onClick() {
              // 选中日期时，清空面板日期，用新选中的日期值计算面板所在月
              delete state.currentDate;
              update(formatDate(dateItem, 'YYYY-MM-DD'));
            }
          };
        }
      }))
    };
  }
};
export default DayPanel;